import ar from "./lang/ar.json";
import cn from "./lang/cn.json";
import en from "./lang/en.json";
import es from "./lang/es.json";
import hi from "./lang/hi.json";
import hk from "./lang/hk.json";
import id from "./lang/in.json";
import ja from "./lang/ja.json";
import ko from "./lang/ko.json";
import pt from "./lang/pt.json";
import ru from "./lang/ru.json";
import th from "./lang/th.json";
import tr from "./lang/tr.json";
import vi from "./lang/vi.json";
import aiselectAr from "./aiselect/ar.json";
import aiselectCn from "./aiselect/cn.json";
import aiselectEn from "./aiselect/en.json";
import aiselectHk from "./aiselect/hk.json";
import aiselectPt from "./aiselect/pt.json";
import aiselectVi from "./aiselect/vi.json";
import brokerAr from "./broker/ar.json";
import brokerCn from "./broker/cn.json";
import brokerEn from "./broker/en.json";
import brokerHk from "./broker/hk.json";
import brokerPt from "./broker/pt.json";
import brokerVi from "./broker/vi.json";

/** 合并独立语言包，避免主语言包缓存未更新时 key 无法解析 */
function withPacks(base, ...packs) {
  return Object.assign({}, base, ...packs);
}

export default {
  "zh-CN": withPacks(cn, aiselectCn, brokerCn),
  "zh-HK": withPacks(hk, aiselectHk, brokerHk),
  ar: withPacks(ar, aiselectAr, brokerAr),
  en: withPacks(en, aiselectEn, brokerEn),
  es,
  hi,
  id,
  ja,
  ko,
  pt: withPacks(pt, aiselectPt, brokerPt),
  ru,
  th,
  tr,
  vi: withPacks(vi, aiselectVi, brokerVi),
};
